import { ApolloClient, InMemoryCache } from '@apollo/client';
import client from '_legacy/api/graphQlClient';

const graphQlClient = (): ApolloClient<InMemoryCache> => client();

export default graphQlClient;
